import React, { Fragment, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { SiSpeedtest } from "react-icons/si";
import { FaRegCalendarAlt } from "react-icons/fa";
import { OPERATE_UPDATE } from "../../../constant-value";
import { operateEditSchema } from "../../../constant-value/schema";
import api from "../../../services/axiosConfig";
import ServiceIcon from "../card-two-side/service-icon";
import DatePicker from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import { toEnglishDigits } from '../../../services/functions';
import DateObject from "react-date-object";



const OperEdit = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [date, setDate] = useState(null);
  const [calendarValue, setCalendarValue] = useState(new Date(state.lastDateG));
  const beforeHandler = () => navigate(-1);

  const [operate, setOperate] = useState({
    operateId: state.id,
    carId: state.carId,
    carTitle: state.car_title,
    lastDateG: calendarValue,
    lastKm: state.lastKm4Edit,
    mtbo: state.mtbo,
    operKindId: state.ok_id,
    serviceType: state.ok_serviceType,
    opTitle: state.ok_title,
    unit:state.unit,
    programKM:state.programKm4Edit,
    remain:state.remain,
    remainUnit:state.remainUnit
  });

  const message = (msg, type) => {
    type === "warn" ? toast.warning(msg) : toast.success(msg);
  };

  const numberChangeHandler = (evt) => {
    // setFieldValue(evt.target.id, parseFloat(evt.target.value));
    const value = evt.target.value; 
    // اگر خالی بود، null یا undefined قرار بده، نه NaN
    if (value === '') {
        setFieldValue(evt.target.id, null);
        setSubmitting(false);
        return;
    }  
    const numberValue = parseFloat(value);
    // اگر عدد معتبر است ذخیره کن، در غیر این صورت null
    const finalValue = isNaN(numberValue) ? null : numberValue; 
    setFieldValue(evt.target.id, finalValue);
    setSubmitting(false);
  };

  const { values, errors, touched, isSubmitting, handleBlur, handleSubmit, setFieldValue, setSubmitting } = useFormik({
    enableReinitialize: true,
    initialValues: operate,
    validationSchema: operateEditSchema,
    onSubmit: (values) => {   
      let selectedDate = values.lastDateG;
      if (!selectedDate){
        message('تاریخ انجام را تعیین نمایید!','warn');
        return;
      }

      // اگر DateObject نیست تبدیلش کن
      if (!(values.lastDateG instanceof DateObject)) {
        selectedDate = new DateObject(values.lastDateG);
      }
      const gregorianDate = toEnglishDigits(
        selectedDate.convert(gregorian, "en").format("YYYY-MM-DD HH:mm:ss")
      );

      const payload = {
        ...values,
        lastDateG: gregorianDate
      };

      api
        .put(`/${OPERATE_UPDATE}/${state.id}`, payload)
        .then((res) => {
          if (res.data.isSuccess) {
            navigate("/all-services");
            message(res.data.message, "success");
          } else {
            message(res.data.message, "warn");
          }
        })
        .catch(error => { 
  
          const msg =

          error.response?.data?.message ||
  
          error.message ||
  
          "خطایی رخ داده است.";
  
          toast.error(msg);          

        })
        .finally(() => {

          setSubmitting(false);

        });
    },
  });

  const stringChangeHandler = (evt) => {
    setFieldValue(evt.target.id, evt.target.value);
  }

  return (
    <Fragment>
      <div className="container py-4">
        {/* دکمه بازگشت */}
        {/* <div className="d-flex justify-content-end mb-3">
          <button className="btn btn-outline-primary btn-sm" onClick={beforeHandler}>
            بازگشت
          </button>
        </div> */}

        {/* کارت اصلی شبیه به CardServicesView */}
        <div className="card mb-4 shadow-sm rounded-4" style={{ fontSize: "0.9rem" }}>
          {/* هدر کارت */}
          <div className="card-header bg-light py-3 px-4 rounded-top-4">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <ServiceIcon categoryId={state.ok_id} size={24} className="me-3"/>
                <div>
                  <span className="fw-bold d-block">{state.opTitle}</span>
                  <small className="text-muted">{state.car_title}</small>
                </div>
              </div>
              <div className="text-primary">
                {state.ok_serviceType === "km" 
                  ? <SiSpeedtest size={22}/> 
                  : <FaRegCalendarAlt size={22}/>}
              </div>
            </div>
          </div>

          {/* بدنه کارت - فرم ویرایش */}
          <div className="card-body p-4">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-3 mb-4">
                {/* کیلومتر آخر */}
                <div className="col-12">
                  <label htmlFor="lastKm" className="form-label fw-semibold small mb-2">
                    آخرین کیلومتر انجام سرویس
                  </label>
                  <input
                    value={values.lastKm}
                    onChange={numberChangeHandler}
                    id="lastKm"
                    type="text"
                    inputMode="numeric"
                    onBlur={handleBlur}
                    className={`form-control rounded-3 ${
                      errors.lastKm && touched.lastKm ? "is-invalid" : ""
                    }`}
                    required
                  />
                  {errors.lastKm && touched.lastKm && (
                    <div className="invalid-feedback small">{errors.lastKm}</div>
                  )}
                </div>

                {/* فیلد واحد */}
                <div className="mb-3">
                  {state.ok_serviceType === "km" ? (
                    <div className="form-floating">
                      <input
                        value={values.unit}
                        id="unit"
                        type="text"
                        className={`form-control ${errors.unit && touched.unit ? 'is-invalid' : ''}`}
                        placeholder="unit"
                        readOnly
                      />
                      <label htmlFor="unit">واحد (کیلومتر)</label>
                      {errors.unit && touched.unit && (
                        <div className="invalid-feedback">{errors.unit}</div>
                      )}
                    </div>
                  ) : (
                    <div className="form-floating">
                      <select
                        value={values.unit}
                        onChange={stringChangeHandler}
                        id="unit"
                        name="unit"
                        className={`form-select ${errors.unit && touched.unit ? 'is-invalid' : ''}`}
                      >
                        <option value="Y">سال</option>
                        <option value="m">ماه</option>
                        <option value="d">روز</option>
                      </select>
                      <label htmlFor="unit">واحد زمانی</label>
                    </div>
                  )}
                </div>

                {/* دوره تکرار */}
                <div className="col-12">
                  <label htmlFor="mtbo" className="form-label fw-semibold small mb-2">
                    دوره تکرار سرویس
                  </label>
                  <input
                    value={values.mtbo}
                    onChange={numberChangeHandler}
                    id="mtbo"
                    type="text"
                    inputMode="numeric"
                    onBlur={handleBlur}
                    className={`form-control rounded-3 ${
                      errors.mtbo && touched.mtbo ? "is-invalid" : ""
                    }`}
                    required
                  />
                  {errors.mtbo && touched.mtbo && (
                    <div className="invalid-feedback small">{errors.mtbo}</div>
                  )}
                </div>

                {/* تاریخ انجام */}
                <div className="col-12">
                  <label htmlFor="OperDonDate" className="form-label fw-semibold small mb-2">
                    آخرین تاریخ انجام
                  </label>
                  <div className="border rounded-3 p-2 bg-white">
                    <DatePicker
                      inputClass={`form-control ${errors.lastDateG && touched.lastDateG ? 'is-invalid' : ''}`}
                      calendar={persian}
                      locale={persian_fa}
                      value={values.lastDateG || ""}
                      // onChange={setDate}
                      onChange={(value) => {
                        setFieldValue("lastDateG", value);
                      }}
                      format="YYYY/MM/DD"
                      calendarPosition="bottom-right"
                    />
                    {/* <DatePicker
                      defaultValue={calendarValue}
                      round="x4"
                      position="center"
                      id="OperDonDate"
                      onBlur={handleBlur}
                      onChange={(e) => dateChangeHandler(e)}
                      className="form-control border-0"
                    /> */}
                  </div>
                  {errors.operDonDate && touched.operDonDate && (
                    <div className="invalid-feedback d-block small">
                      {errors.operDonDate}
                    </div>
                  )}
                </div>
              </div>

              {/* دکمه‌های اقدام */}
              <div className="d-flex justify-content-between gap-3">
                <button
                  type="button"
                  onClick={beforeHandler}
                  className="btn btn-outline-secondary btn-sm flex-grow-1"
                >
                  انصراف
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-success btn-sm flex-grow-1"
                >
                  {isSubmitting ? "در حال ذخیره..." : "تایید و ذخیره"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default OperEdit;